import {
    setExpiringCookies,
    getCookie
} from '../global/_cookies';
let Cookies = require('js-cookie')

const areYouIE = () => {
    var cache = {
        ieVersion: navigator.userAgent.match(/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/),
        $html: $('html'),
    };

    if (cache.ieVersion !== null) {
        if (cache.ieVersion[2] == 11) cache.$html.addClass('ie11');
        else
        if (cache.ieVersion[2] == 10) cache.$html.addClass('ie10');
        else
        if (cache.ieVersion[2] == 9) cache.$html.addClass('ie9');
        else
        if (cache.ieVersion[2] == 8) document.body.setAttribute("class", "ie8");
        if (cache.ieVersion[2] == 7) document.body.setAttribute("class", "ie7");
        if (cache.ieVersion[2] == 6) document.body.setAttribute("class", "ie6");
        return cache.ieVersion;
    }
};

// Outdated
// const whoAreYou = () => {
//     var $html = $('html');
//     //Add Operating System class
//     $html.attr({
//         'data-browser-os': browserDetect.OS,
//         'data-browser-vendor': browserDetect.browser,
//         'data-browser-version': browserDetect.version
//     });
// };

const browserDetect = {
    init: function() {
        this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
        this.version = this.chooseVersionSearch();
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
        this.compatIE = navigator.userAgent.indexOf("Trident") > -1 && navigator.userAgent.indexOf("MSIE 7.0") > -1;
        this.botUserAgent = this.checkForBotUserAgent();
    },

    checkForBotUserAgent: function() {
        var returnVariable = false,
            botUserAgentIdentifiers = ['Google Page Speed Insights', 'Googlebot', 'Search Console', 'Baiduspider', 'ia_archiver', 'R6_FeedFetcher', 'NetcraftSurveyAgent', 'Sogou web spider', 'bingbot', 'Yahoo! Slurp', 'facebookexternalhit', 'PrintfulBot', 'msnbot', 'Twitterbot', 'UnwindFetchor', 'urlresolver', 'Butterfly', 'TweetmemeBot'];
        $(botUserAgentIdentifiers).each(function() {
            if (navigator.userAgent.indexOf(String(this)) > -1) returnVariable = true;
        });
        return returnVariable;
    },

    chooseVersionSearch: function() {
        if (this.browser === "Explorer" && navigator.userAgent.indexOf("Trident/") > -1) return this.getIEVersion(navigator.userAgent) || this.getIEVersion(navigator.appVersion) || "an unknown version";
        else return this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
    },

    getIEVersion: function(e) {
        var theVersion = (e.indexOf("MSIE 7.0") > -1) ? 7 : (e.indexOf("Trident/7.0") > -1) ? 11 : (e.indexOf("Trident/6.0") > -1) ? 10 : (e.indexOf("Trident/5.0") > -1) ? 9 : (e.indexOf("Trident/4.0") > -1) ? 8 : 12;
        return theVersion;
    },

    searchString: function(e) {
        for (var t = 0; t < e.length; t++) {
            var n = e[t].string,
                r = e[t].prop;
            this.versionSearchString = e[t].versionSearch || e[t].identity;
            if (n) {
                if (n.indexOf(e[t].subString) != -1) return e[t].identity;
            } else if (r) return e[t].identity;
        }
    },

    searchVersion: function(e) {
        var t = e.indexOf(this.versionSearchString);
        if (t == -1) return;
        return parseFloat(e.substring(t + this.versionSearchString.length + 1));
    },

    dataBrowser: [{
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
    }, {
        string: navigator.vendor,
        subString: "Apple",
        identity: "Safari",
        versionSearch: "Version"
    }, {
        prop: window.opera,
        identity: "Opera",
        versionSearch: "Version"
    }, {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
    }, {
        string: navigator.userAgent,
        subString: "Netscape",
        identity: "Netscape"
    }, {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer",
        versionSearch: "MSIE"
    }, {
        string: navigator.userAgent,
        subString: "Gecko",
        identity: "Mozilla",
        versionSearch: "rv"
    }, {
        string: navigator.userAgent,
        subString: "Mozilla",
        identity: "Netscape",
        versionSearch: "Mozilla"
    }, {
        string: navigator.userAgent,
        subString: ".NET",
        identity: "Explorer",
        versionSearch: "rv"
    }],
    dataOS: [{
        string: navigator.platform,
        subString: "Win",
        identity: "Windows"
    }, {
        string: navigator.platform,
        subString: "Mac",
        identity: "Mac"
    }, {
        string: navigator.userAgent,
        subString: "iPhone",
        identity: "iPhone"
    }, {
        string: navigator.userAgent,
        subString: "iPad",
        identity: "iPad"
    }, {
        string: navigator.userAgent,
        subString: "Android",
        identity: "Android"
    }, {
        string: navigator.platform,
        subString: "Linux",
        identity: "Linux"
    }]
};

const outdatedBrowserCheck = () => {
    if (typeof browserDetect.browser == 'undefined') {
        browserDetect.init();
    }
    var userBrowser = browserDetect.browser,
        userBrowserVersion = browserDetect.version,
        ua = navigator.userAgent,
        badChrome = (userBrowser == "Chrome" && userBrowserVersion < 110),
        badSafari = (userBrowser == "Safari" && userBrowserVersion < 13),
        badFirefox = (userBrowser == "Firefox" && userBrowserVersion < 110),
        badAndroid = (ua.indexOf("Android") > -1 && parseFloat(ua.slice(ua.indexOf("Android")+8)) <= 4.4),
        badAndroidChrome = (ua.indexOf("Android") > -1) && (userBrowser == "Chrome" && userBrowserVersion < 82),
        badSamsung = (ua.indexOf("SamsungBrowser") > -1 && parseFloat(ua.slice(ua.indexOf("SamsungBrowser") + 15).substring(0, 3)) <= 6.4),
        iPhone = ua.match(/iPhone/i),
        badIos = (ua.indexOf("iPhone") > -1 && parseFloat(iPhone.input.slice(iPhone.input.indexOf('OS') + 3)) <= 12),
        badEdge = (ua.indexOf("Edge") > -1 && parseFloat(ua.slice(ua.indexOf("Edge") + 5).substring(0, 2)) <= 18),
        badEdgeChromium = (ua.indexOf("Edg") > -1 && parseFloat(ua.slice(ua.indexOf("Edg") + 4)) <= 109),
        badIE = (ua.indexOf("Trident") > -1),
        badOpera = (ua.indexOf("OPR") > -1),
        isSilk = (ua.indexOf("Silk") > -1);

    var badBrowsers = badChrome || badSafari || badFirefox || badAndroid || badAndroidChrome || badSamsung || badIos || badEdge || badEdgeChromium || badOpera || badIE || isSilk;
    if (badBrowsers && (!getCookie("outdatedBrowserShown") || getCookie("outdatedBrowserShown") != 'true')) {
        setExpiringCookies("outdatedBrowserShown", "true", 30);
        window.location.replace('/html/browserUpdate.html');
    }
};

export {
    browserDetect,
    areYouIE,
    outdatedBrowserCheck,
}
